import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components/macro';
import media from 'styles/media';
import {
  ProfileFormItems,
  ProfileFormValues,
  ProfileFormControl,
} from 'types/profile';
import * as MESSAGES from 'constants/messages';
import { NO_SELECT_NUMBER } from 'constants/form';
import { Selectbox } from 'components/atoms';
import { Field } from 'components/molecules';

type CareerAnnualIncomeFormFieldProps = {
  error: string | undefined;
  annualIncomes: ProfileFormItems['annualIncomes'];
  control: ProfileFormControl<{
    career: Pick<ProfileFormValues['career'], 'annualIncomeId'>;
  }>;
};

const StyledSelectbox = styled(Selectbox)`
  width: 368px;

  ${media.mobile} {
    width: 100%;
  }
`;

const CareerAnnualIncomeFormField: FC<CareerAnnualIncomeFormFieldProps> = props => {
  const { error, annualIncomes, control } = props;

  return (
    <Field
      label={MESSAGES.PROFILE.FIELD.CAREER_ANNUAL_INCOME.LABEL}
      required
      locked
    >
      <Controller
        control={control}
        name="career.annualIncomeId"
        render={innerProps => (
          <StyledSelectbox
            value={innerProps.value}
            error={error}
            options={annualIncomes}
            noSelectValue={NO_SELECT_NUMBER}
            aria-label={MESSAGES.PROFILE.FIELD.CAREER_ANNUAL_INCOME.LABEL}
            onChange={innerProps.onChange}
            onBlur={innerProps.onBlur}
          />
        )}
      />
    </Field>
  );
};

export default CareerAnnualIncomeFormField;
